<template>
  <div>
    <slot name="loading" v-if="$statsigState && $statsigState.loading">
      <BaseLoader size="xl" />
    </slot>
    <template v-else-if="$statsigState && $statsigState.initialized && isFeatureEnabled">
      <slot name="new" />
    </template>
    <template v-else>
      <slot name="old" />
    </template>
  </div>
</template>

<script>
import BaseLoader from '@/components/BaseLoader.vue';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';

export default {
  name: 'FeatureFlagSwitcher',
  components: { BaseLoader },
  props: {
    flag: {
      type: String,
      required: true
    }
  },
  computed: {
    isFeatureEnabled() {
      const { isFeatureEnabled } = useFeatureFlags();
      return isFeatureEnabled(this.flag);
    }
  }
};
</script>
